import FormControlLabel from '@mui/material/FormControlLabel';

import { Radio as DsRadio } from '@cast/design-system';
import { RffRadioGroup } from '@cast/shared-rff-ui';

import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

const RESOURCE_OFFERING_OPTIONS = [
  {
    value: 'on-demand',
    label: 'On-Demand',
    testId: 'resource-offering-radio-on-demand',
  },
  {
    value: 'spot',
    label: 'Spot',
    testId: 'resource-offering-radio-spot',
  },
] as const;

export const ResourceOfferingSection = () => {
  return (
    <InlineWithDescription
      description={
        <ControlWithDescription label="Resource offering">
          Choose whether the node should be provisioned as on-demand or spot.
        </ControlWithDescription>
      }
      controls={
        <RffRadioGroup name="resourceOffering" sx={{ gap: 8 }}>
          {RESOURCE_OFFERING_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <DsRadio
                  value={option.value}
                  size="small"
                  testId={option.testId}
                />
              }
              label={option.label}
              sx={{
                ml: 0,
                '& .MuiFormControlLabel-label': { typography: 'P12R', pl: 8 },
              }}
            />
          ))}
        </RffRadioGroup>
      }
    />
  );
};
